import { render, staticRenderFns } from "./factura-form.vue?vue&type=template&id=579e6636&scoped=true&"
import script from "./factura-form.vue?vue&type=script&lang=js&"
export * from "./factura-form.vue?vue&type=script&lang=js&"
import style0 from "./factura-form.vue?vue&type=style&index=0&id=579e6636&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579e6636",
  null
  
)

export default component.exports